<script lang="ts">
  import type {
    FacilityInformation,
    InformationValidation,
    ResidenceTypes,
  } from "../../helpers/types";
  import useMovingFlow from "../../providers/useMovingFlow";
  import Card from "../atoms/Card.svelte";
  import ErrorText from "../atoms/ErrorText.svelte";
  import Heading from "../atoms/Heading.svelte";
  import NumberInput from "../atoms/NumberInput.svelte";
  import TextInput from "../atoms/TextInput.svelte";

  interface Props {
    facilityInformation: FacilityInformation;
    informationValidator: InformationValidation;
    hasPressedContinue?: boolean;
  }

  let {
    facilityInformation = $bindable(),
    informationValidator = $bindable(),
    hasPressedContinue = $bindable(false),
  }: Props = $props();

  const originalZipcode = facilityInformation ? facilityInformation.zipcode : undefined;
  let changedZipcode = $derived(
    originalZipcode && originalZipcode.toString() !== facilityInformation.zipcode?.toString()
  );

  const { state: store } = useMovingFlow();

  const requiresLimePurchase = $store.context.requiresLimePurchase;
</script>

<Card>
  <Heading>Var är din nya bostad?</Heading>
  <div class="flex flex-col space-y-2">
    <div class=" ">
      {#if informationValidator.errors.address || (!facilityInformation.address && hasPressedContinue)}
        <ErrorText>Fyll i gatuadress</ErrorText>
      {:else}
        <label for="adress" class="block">Gatuadress</label>
      {/if}
      <TextInput
        autoFocus={false}
        id="adress"
        disabled={requiresLimePurchase}
        required={true}
        name="adress"
        {hasPressedContinue}
        class="w-full"
        error={informationValidator.errors.address ||
          (!facilityInformation.address && hasPressedContinue)}
        bind:value={facilityInformation.address}
      />
    </div>
    <div class=" flex space-x-3">
      <div class="w-32">
        {#if informationValidator.errors.zipcode || (!facilityInformation.zipcode && hasPressedContinue)}
          <ErrorText>Postnummer</ErrorText>
        {:else}
          <label for="zipcode" class="block">Postnummer</label>
        {/if}
        <NumberInput
          autoFocus={false}
          required={true}
          id="zipcode"
          {hasPressedContinue}
          disabled={requiresLimePurchase}
          name="zipcode"
          class="w-28"
          error={informationValidator.errors.zipcode ||
            (!facilityInformation.zipcode && hasPressedContinue)}
          bind:value={facilityInformation.zipcode}
        />
      </div>
      <div class="w-full">
        {#if informationValidator.errors.city || (!facilityInformation.city && hasPressedContinue)}
          <ErrorText>Fyll i postort</ErrorText>
        {:else}
          <label for="city" class="block">Postort</label>
        {/if}
        <TextInput
          autoFocus={false}
          id="city"
          {hasPressedContinue}
          required={true}
          disabled={requiresLimePurchase}
          name="city"
          class="w-full"
          error={informationValidator.errors.city ||
            (!facilityInformation.city && hasPressedContinue)}
          bind:value={facilityInformation.city}
        />
      </div>
    </div>
    {#if changedZipcode}
      <span class="block text-Violet700 text-sm -mt-2"
        >Du har angett ett annat postnummer än tidigare,<br />vilket kan påverka prisuppskattningen
        du fått.</span
      >
    {/if}
    {#if facilityInformation.residenceType === "house"}
      <div class="w-2/3">
        <label for="formerResidence" class="block"
          >Namn på tidigare boende (frivillig uppgift)</label
        >
        <TextInput
          autoFocus={false}
          id="formerResidence"
          name="formerResidence"
          class="w-full"
          error={informationValidator.errors.propertyOwner}
          bind:value={facilityInformation.propertyOwner}
        />
      </div>
    {/if}
    {#if facilityInformation.residenceType === "apartment"}
      <div class="w-2/3">
        <label for="propertyOwner" class="block">Fastighetsägare/hyresvärd</label>
        <TextInput
          autoFocus={false}
          id="propertyOwner"
          name="propertyOwner"
          class="w-full"
          error={informationValidator.errors.propertyOwner}
          bind:value={facilityInformation.propertyOwner}
        />
      </div>
      <div class="w-full">
        <label for="apartmentNumber" class="block">Lägenhetsnummer (frivillig uppgift)</label>
        <TextInput
          autoFocus={false}
          id="apartmentNumber"
          name="apartmentNumber"
          class="w-1/3"
          error={informationValidator.errors.apartmentNumber}
          bind:value={facilityInformation.apartmentNumber}
        />
      </div>
      <div class="w-2/3">
        <label for="formerResidence" class="block"
          >Namn på förra hyresgästen (frivillig uppgift)</label
        >
        <TextInput
          autoFocus={false}
          id="formerResidence"
          name="formerResidence"
          class="w-full"
          error={informationValidator.errors.formerResidence}
          bind:value={facilityInformation.formerResidence}
        />
      </div>
    {/if}
  </div>
</Card>
